-- A derive is an ordinary exported comptime function. It inspects the record
-- being declared and returns checked recipes for the members it wants to add.
const derive2 = require("types.derive")
const types2 = require("types")

local labels = {}

-- Generated methods forward to ordinary runtime functions. This keeps their
-- behavior in normal, typed Nupp rather than embedding code in the recipe.
function labels.render(typeName: string): string
    return "<" .. typeName .. ">"
end

@comptime
function labels.derive(info: types.derive.Info): types.derive.Result<any>
    if info.kind ~= "record" then
        return derive2.error("Label can be derived only for records", info.reference)
    end

    return derive2.implement{
        methods = {
            label = derive2.member{
                signature = types2.functiontype(
                    types2.pack({
                        info.ownertype
                    }),
                    types2.pack({
                        types2.string
                    })
                ),
                forward = derive2.forward{
                    helper = derive2.helper(labels, "render"),
                    arguments = {derive2.constant(info.name)},
                },
            },
        },
    }
end

@derive(labels.derive)
record labels.User
    name: string
    active: boolean
end

local user = new labels.User(name = "Ada", active = true)
print(user:label()) -- <User>

-- try breaking it: change `record` to `interface`, and read the provider's
-- diagnostic at the declaration

return labels
